<template>
  <div
    class="fixed flex justify-between w-full h-20 px-8"
    style="z-index: 999"
    :key="headerKey"
  >
    <div class="flex items-center">
      <Logo class="!text-5xl" />

      <router-link
        to="/app/tools"
        class="ml-8"
        v-show="$route.path !== '/app/tools'"
      >
        <div class="btn btn-secondary">
          <i class="mr-2 fa fa-home" aria-hidden="true"></i>
          <span class="text-xs uppercase">Modules</span>
        </div>
      </router-link>

      <button
        @click="$router.back()"
        v-show="$route.path !== '/app/tools'"
        class="ml-4 animate__animated animate__fadeInLeft"
      >
        <div class="btn btn-secondary">
          <i class="mr-2 fas fa-arrow-left"></i>
          <span class="text-xs uppercase">Retour</span>
        </div>
      </button>
    </div>

    <div class="flex items-center gap-x-4">
      <div class="flex items-center text-lg gap-x-3">
        <div class="dropdown">
          <div
            tabindex="0"
            class="flex items-center justify-center ml-2 rounded-full btn btn-ghost text-base-content"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              class="inline-block w-6 h-6 stroke-current md:mr-2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
              ></path>
            </svg>
            thèmes
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1792 1792"
              class="inline-block w-4 h-4 ml-1 fill-current"
            >
              <path
                d="M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"
              ></path>
            </svg>
          </div>
          <ul
            tabindex="0"
            class="p-2 overflow-y-auto shadow menu dropdown-content gap-y-1 bg-base-100 text-base-content rounded-box w-52 max-h-64"
          >
            <li
              class="text-left no-underline normal-case first-letter:uppercase btn btn-sm btn-ghost hover:no-underline"
              :class="{ 'btn-active': currentTheme === theme }"
              v-for="theme of themes"
              :key="theme"
              @click="setTheme(theme)"
            >
              {{ capitalizeFirstLetter(theme.trim()) || "Système" }}
            </li>
          </ul>
        </div>
      </div>

      <div class="py-4 divider divider-vertical"></div>

      <div class="dropdown dropdown-end">
        <div
          tabindex="0"
          class="w-12 h-12 btn btn-square btn-circle bg-primary-focus text-primary-content online avatar"
        >
          <span class="text-xl font-bold tracking-wide pointer-events-none">{{
            $user.getUser.userName[0]
          }}</span>
        </div>
        <ul
          tabindex="0"
          class="p-2 shadow menu dropdown-content bg-base-100 text-base-content rounded-box w-52"
        >
          <div>
            <p class="text-xl font-semibold text-center">
              {{ $user.getUser.userName }}
            </p>
            <p class="text-sm font-light text-center">
              {{ $user.getUser.email }}
            </p>
          </div>
          <li>
            <button class="mt-4 btn btn-secondary" @click="doLogout">
              Se déconnecter
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import authMixin from "@/utils/mixins/auth.mixin.js";
import Logo from "@/components/Logo.vue";
export default {
  name: "Header",
  components: { Logo },
  mixins: [authMixin],
  data() {
    return {
      showMenu: false,
      lang: null,
      currentTheme: "",
      themes: [
        "",
        "stratochange",
        // 'light',
        "dark",
        //  'cupcake',
        //'bumblebee',
        //'emerald',
        //'corporate',
        //"synthwave",
        //"retro",
        //"cyberpunk",
        //"valentine",
        //"halloween",
        //"garden",
        //"forest",
        //"aqua",
        //"lofi",
        //"pastel",
        //"fantasy",
        //"wireframe",
        //"black",
        //"luxury",
        //"dracula",
        // "cmyk",
      ],
      listLg: [
        { label: "fr", value: "Français" },
        { label: "en", value: "English" },
        { label: "de", value: "Deutchland" },
      ],
      currentLg: "fr",
      currentLgImg: "",
      fullScreen: false,
      messages: 3,
      hover: false,
      sidebarVisible: true,
      lolol: ["fr", "en", "de"],

      currentRatio: 1,
      maxZoom: 1.5,
      minZoom: 0.5,

      showZoom: false,
      headerKey: 0,
    };
  },

  created() {
    this.setTheme(localStorage.getItem("themedata"))
    window.addEventListener("beforeunload", () => {
      console.log(this.$route);
      localStorage.setItem("showZoom", true);
    });
  },

  mounted() {
    this.currentTheme =
      document.getElementsByTagName("html")[0].getAttribute("data-theme") ?? "";
    if (localStorage.getItem("showZoom") !== null) {
      this.showZoom = true;
      setTimeout(() => {
        localStorage.removeItem("showZoom");
      }, 450);
    }
  },

  updated() {},

  watch: {
    $route(to, from) {
      if (from.path !== to.path) {
        this.showZoom =
          from.path === "/app/participants" && to.path !== "/app/files"
            ? true
            : false;
        this.headerKey += 1;
      }
    },

    currentTheme(theme) {
      document
        .getElementsByTagName("html")[0]
        .setAttribute("data-theme", theme);
    },
  },

  methods: {
    setTheme(theme) {
      this.currentTheme = theme;
      localStorage.setItem('themedata', theme)
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleFullScreen() {
      const isInFullScreen = this.isInFullScreen();

      var docElm = document.documentElement;
      if (!isInFullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
      this.fullScreen = !isInFullScreen;
    },

    isInFullScreen() {
      return (
        (document.fullscreenElement && document.fullscreenElement !== null) ||
        (document.webkitFullscreenElement &&
          document.webkitFullscreenElement !== null) ||
        (document.mozFullScreenElement &&
          document.mozFullScreenElement !== null) ||
        (document.msFullscreenElement && document.msFullscreenElement !== null)
      );
    },

    zoom(tag) {
      if (
        this.currentRatio > this.minZoom &&
        this.currentRatio < this.maxZoom
      ) {
        this.currentRatio =
          tag === "in" ? this.currentRatio + 0.1 : this.currentRatio - 0.1;
        // tag === 'in' ? document.querySelector('.module').style.setProperty('transform-origin', '50% 0%') : document.querySelector('.module').style.setProperty('transform-origin', '50% 50%')
        document
          .querySelector(".module")
          .style.setProperty("transform", "scale(" + this.currentRatio + ")");
      } else {
        if (this.currentRatio >= this.maxZoom && tag === "out") {
          this.currentRatio -= 0.1;
          document
            .querySelector(".module")
            .style.setProperty("transform", "scale(" + this.currentRatio + ")");
        }

        if (this.currentRatio <= this.minZoom && tag === "in") {
          this.currentRatio += 0.1;
          // document.querySelector('.module').style.setProperty('transform-origin', '50% 0%')
          document
            .querySelector(".module")
            .style.setProperty("transform", "scale(" + this.currentRatio + ")");
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999;

  div {
    display: inline-block;
    vertical-align: top;
  }

  .header--left {
    margin-left: 1%;
    height: 90px;
    width: 80px;
    background: white;
    border-radius: 0 0 3rem 3rem;
    // overflow: hidden;
    position: relative;

    .hl--logo {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      overflow: hidden;
      position: absolute;
      bottom: 5px;
      right: 5px;
      cursor: pointer;

      &:hover {
        transform: rotate(360deg) scale(0.9);
      }

      img {
        width: 70px;
      }
    }

    .hl--home {
      border: solid 0.11px;
      position: absolute;
      right: -180%;
      top: 20px;
      padding: 10px;
      margin-right: 20px;
      cursor: pointer;
      background-color: #777;
      color: #fff;
      transform: scale(0.8);

      .ico--angle {
        font-size: 0.7em;
        display: inline-block;
        margin: 0 5px;
        transform: translateY(-1.5px);
      }

      &:hover {
        transform: translateX(10px) scale(0.85);
      }
    }

    .hl--zoom {
      position: absolute;
      right: -320%;
      top: 17px;
      padding: 10px;
      transform: scale(0.8);
      display: flex;
      flex-wrap: nowrap;

      .ico--zoom {
        width: 25px;
        height: 25px;
        background-color: #777;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 0.8em;
        color: #fff;
        cursor: pointer;

        &:hover {
          transform: rotate(360deg) scale(1.35);
        }
      }

      .zoom--text {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 0 13px;
        height: 25px;
        font-size: 0.9em;
      }
    }
  }

  .header--logo {
    width: 230px;
    height: 70px;
    margin-left: calc(49% - 115px - 80px);

    img {
      width: 70%;
      margin: 7% 10%;
      cursor: pointer;

      &:hover {
        transform: scale(0.9);
      }
    }
  }

  .header--right {
    height: 30px;
    float: right;
    margin-right: 2%;
    margin-top: 10px;

    .hr_ico {
      font-size: 1.4em;
      font-weight: 600;
      display: inline-block;
      padding: 5px;
      margin: 5px;
      color: #777;
      cursor: pointer;
      text-align: center;

      &:hover {
        transform: scale(1.2);
        color: #aaa;
      }
    }

    .hr--lg-current {
      display: inline-block;
      width: 20px;
      height: 20px;
      overflow: hidden;
      border-radius: 0.8rem;
      cursor: pointer;
      margin-top: 12px;
      margin-left: 5px;

      img {
        width: 20px;
        height: 20px;
      }

      &:hover {
        transform: scale(1.2);
      }
    }

    .hr--acount-pp {
      display: inline-block;
      width: 40px;
      height: 40px;
      overflow: hidden;
      margin-left: 20px;
      border-radius: 5px;
      cursor: pointer;

      img {
        width: 40px;
      }

      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>
